import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { catchError, Observable, throwError } from 'rxjs';

@Injectable()
export class LogoutInterceptor implements HttpInterceptor {
  private readonly _auth = inject(AuthService);

  intercept<T>(req: HttpRequest<T>, next: HttpHandler): Observable<HttpEvent<T>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          this._auth.logout();
        }
        return throwError(() => error);
      })
    );
  }
}
